import React from 'react';
import styled from 'styled-components';
import { colors } from '../ui-components';

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 * @param {element} children collection of child rich-text nodes
 */

const RichUnorderedListItem = (node, children) => <StyledRichUnorderedListItem>{children}</StyledRichUnorderedListItem>;

const StyledRichUnorderedListItem = styled.ul`

  margin-top: 0;
  list-style: disc;
  margin-left: 19px;
  margin-right: 14px;
  color: ${colors.crederaRed};
  font-size: 23px;

  li p {
    display: inline-flex;   
    align-items: center;
  }

  li ol li {
    margin-left: 12px;

    p::before {
      content: none;
    }  
  }

  li p b, a, u, i, span {
    display: contents;
  }

`;

export default RichUnorderedListItem;
